import { AppDispatch, RootState } from 'lib/store';

type RouteEntryDef<T = undefined> = {
  selector?: (state: RootState) => T;
  resolve: (data: T) => string | null;
  effect?: (data: T, dispatch: AppDispatch) => void;
};

export type RouteEntry = {
  execute: (state: RootState, dispatch: AppDispatch) => string | null;
};

export function defineRoute<T>(def: RouteEntryDef<T>): RouteEntry {
  return {
    execute: (state, dispatch) => {
      const data = (def.selector ? def.selector(state) : undefined) as T;
      const slug = def.resolve(data);
      if (slug !== null) {
        def.effect?.(data, dispatch);
      }
      return slug;
    },
  };
}
